export default __webpack_public_path__ + "static/media/hod.b3b21e60.png";